import React, { PropsWithChildren } from 'react';
import HeroRibbon from 'components/Hero/HeroRibbon';
import { HeroData } from '../types';

type HeroRibbonBlockProps = {
  hero_with_side_image: HeroData;
};

const HeroRibbonBlock: React.FC<PropsWithChildren<HeroRibbonBlockProps>> = ({
  hero_with_side_image,
  children,
}) => {
  return (
    <HeroRibbon
      heading={hero_with_side_image.heading}
      subhead={hero_with_side_image.subheading ?? undefined}
      data-cy="RibbonHeroBanner">
      {children}
    </HeroRibbon>
  );
};

export default React.memo(HeroRibbonBlock);
